import { render, staticRenderFns } from "./Cate.vue?vue&type=template&id=21408312&"
import script from "./Cate.vue?vue&type=script&lang=js&"
export * from "./Cate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports